"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AWTRecordBatcher_1 = require("../common/AWTRecordBatcher");
var AWTBondSerializer_1 = require("../common/AWTBondSerializer");
var AWTRetryPolicy_1 = require("../common/AWTRetryPolicy");
var AWTKillSwitch_1 = require("../common/AWTKillSwitch");
var Version = require("./Version");
var FlushCheckTimer = 250;
var RequestSizeLimitBytes = 2936012; //approx 2.8 Mb
var MaxRetries = 4;
var AWTTransmissionManager = /** @class */ (function () {
    function AWTTransmissionManager() {
    }
    AWTTransmissionManager.initialize = function (config) {
        this._inboundQueues.push([]);
        this._recordBatcher = new AWTRecordBatcher_1.default(RequestSizeLimitBytes, this._outboundQueue);
        this._newEventsAllowed = true;
        if (typeof Uint8Array === 'undefined') {
            this._urlString += '&content-encoding=base64';
        }
        this._sendingTimer = config.sendingTimer;
        this._urlString = config.collectorUrl + this._urlString + '&x-apikey=';
    };
    //Push the event into the inbound queue and return
    AWTTransmissionManager.sendEvent = function (event) {
        var _this = this;
        if (this._newEventsAllowed) {
            //Add event to the last inbound queue
            this._inboundQueues[this._inboundQueues.length - 1].push(event);
            if (!this._running && this._timeout < 0 && !this._isCurrentlyFlushing) {
                this._timeout = setTimeout(function () { return _this._batchAndSendEvents(false); }, this._sendingTimer);
            }
        }
    };
    AWTTransmissionManager.flushAndTeardown = function () {
        this._newEventsAllowed = false;
        this._batchAndSendEvents(true);
    };
    AWTTransmissionManager.flush = function (callback) {
        this._inboundQueues.push([]);
        if (!this._isCurrentlyFlushing) {
            this._isCurrentlyFlushing = true;
            this._flush(callback);
        }
        else {
            this._flushQueue.push(callback);
        }
    };
    AWTTransmissionManager._batchAndSendEvents = function (isTeardown) {
        this._running = true;
        while (this._inboundQueues[0].length > 0 && this._outboundQueue.length < 1) {
            this._recordBatcher.addEventToBatch(this._inboundQueues[0].pop());
        }
        if (this._outboundQueue.length === 0) {
            this._recordBatcher.flushBatch();
        }
        this._sendRequest(this._outboundQueue.pop(), 0, isTeardown);
    };
    AWTTransmissionManager._retryRequestIfNeeded = function (conn, request, tokenCount, apikey, retryCount) {
        var _this = this;
        var shouldRetry = true;
        if (conn && typeof conn.status !== 'undefined') {
            var killedTokens = this._killSwitch.setKillSwitchTenants(conn.getResponseHeader('kill-tokens'), conn.getResponseHeader('kill-duration-seconds'));
            killedTokens.forEach(function (key) {
                delete request[key];
                tokenCount--;
            });
            if (!AWTRetryPolicy_1.default.shouldRetryForStatus(conn.status) || tokenCount <= 0) {
                shouldRetry = false;
            }
        }
        if (shouldRetry && retryCount < MaxRetries) {
            setTimeout(function () { return _this._sendRequest(request, retryCount + 1, false); }, AWTRetryPolicy_1.default.getMillisToBackoffForRetry(retryCount));
        }
        else {
            this._handleRequestFinished(null);
        }
    };
    AWTTransmissionManager._sendRequest = function (request, retryCount, isTeardown) {
        var _this = this;
        try {
            var conn_1 = new XMLHttpRequest();
            var tokenCount_1 = 0;
            var apikey_1 = '';
            Object.keys(request).forEach(function (token) {
                if (!_this._killSwitch.isTenantKilled(token)) {
                    if (apikey_1.length > 0) {
                        apikey_1 += ',';
                    }
                    apikey_1 += token;
                    tokenCount_1++;
                }
                else {
                    delete request[token];
                }
            });
            conn_1.open('POST', this._urlString + apikey_1, !isTeardown);
            if (!isTeardown) {
                conn_1.ontimeout = function () {
                    _this._retryRequestIfNeeded(conn_1, request, tokenCount_1, apikey_1, retryCount);
                };
                conn_1.onerror = function () {
                    _this._retryRequestIfNeeded(conn_1, request, tokenCount_1, apikey_1, retryCount);
                };
                conn_1.onload = function () {
                    _this._handleRequestFinished(conn_1);
                };
            }
            if (tokenCount_1 > 0) {
                var blob = AWTBondSerializer_1.default.getPayloadBlob(request, tokenCount_1);
                if (typeof Uint8Array === 'undefined') {
                    conn_1.send(AWTBondSerializer_1.default.base64Encode(blob));
                }
                else {
                    conn_1.send(new Uint8Array(blob));
                }
            }
            else if (isTeardown) {
                this._handleRequestFinished(null);
            }
        }
        catch (e) {
            this._handleRequestFinished(null);
        }
    };
    AWTTransmissionManager._handleRequestFinished = function (conn) {
        var _this = this;
        if (conn) {
            this._killSwitch.setKillSwitchTenants(conn.getResponseHeader('kill-tokens'), conn.getResponseHeader('kill-duration-seconds'));
        }
        if (this._inboundQueues[0].length > 0) {
            this._timeout = setTimeout(function () { return _this._batchAndSendEvents(false); }, this._sendingTimer);
        }
        else {
            this._timeout = -1;
            this._running = false;
        }
    };
    AWTTransmissionManager._flush = function (callback) {
        var _this = this;
        if (!this._running) {
            if (this._timeout > -1) {
                clearTimeout(this._timeout);
                this._timeout = -1;
            }
            if (this._inboundQueues[0].length > 0) {
                this._batchAndSendEvents(false);
            }
        }
        this._checkPrimaryInboundQueueEmpty(function () {
            //Move the next queue to be primary
            _this._inboundQueues.shift();
            if (callback !== null && callback !== undefined) {
                callback();
            }
            if (_this._flushQueue.length > 0) {
                setTimeout(function () { return _this._flush(_this._flushQueue.shift()); }, _this._sendingTimer);
            }
            else {
                _this._isCurrentlyFlushing = false;
                if (_this._inboundQueues[0].length > 0) {
                    _this._timeout = setTimeout(function () { return _this._batchAndSendEvents(false); }, _this._sendingTimer);
                }
            }
        });
    };
    AWTTransmissionManager._checkPrimaryInboundQueueEmpty = function (callback) {
        var _this = this;
        if (this._inboundQueues[0].length === 0) {
            this._checkOutboundQueueEmptyAndSent(callback);
        }
        else {
            setTimeout(function () { return _this._checkPrimaryInboundQueueEmpty(callback); }, FlushCheckTimer);
        }
    };
    AWTTransmissionManager._checkOutboundQueueEmptyAndSent = function (callback) {
        var _this = this;
        if (!this._running) {
            callback();
        }
        else {
            setTimeout(function () { return _this._checkOutboundQueueEmptyAndSent(callback); }, FlushCheckTimer);
        }
    };
    AWTTransmissionManager._outboundQueue = [];
    AWTTransmissionManager._inboundQueues = [];
    AWTTransmissionManager._newEventsAllowed = false;
    AWTTransmissionManager._killSwitch = new AWTKillSwitch_1.default();
    AWTTransmissionManager._isCurrentlyFlushing = false;
    AWTTransmissionManager._flushQueue = [];
    AWTTransmissionManager._running = false;
    AWTTransmissionManager._timeout = -1;
    AWTTransmissionManager._urlString = '?qsp=true&content-type=application%2Fbond-compact-binary&client-id=NO_AUTH&sdk-version='
        + Version.FullVersionString;
    return AWTTransmissionManager;
}());
exports.default = AWTTransmissionManager;
